import styled from 'styled-components';
import { colorCSS, cssColorsFromBackgroundField, radius } from '../../styles';
export const AccordionButton = styled.button `
  background: inherit;
  color: inherit;
  margin: 0;
  padding: 0;
  border: none;
`;
export const GridItem = styled.div `
  ${({ backgroundField }) => cssColorsFromBackgroundField(backgroundField)}
  border-radius: ${radius['medium']};
  min-height: 6.05rem;
  padding: 0.9rem 1.25rem 1.15rem 2.5rem;
  > h3 {
    margin: 0;
    button {
      font-weight: inherit;
      position: relative;
      text-align: left;
      span {
        position: absolute;
        left: -1.25rem;
      }
    }
  }
`;
export const GridItemContent = styled.div `
  font-size: 90%;
  padding: 0.5rem 0;
  > *:last-child {
    margin-bottom: 0;
  }
`;
export const List = styled.div `
  text-align: left;
`;
export const ListItem = styled.div `
  border-bottom: 0.5px solid ${colorCSS('N50')};
  padding: 1rem 0;
  > h3 {
    margin: 0;
    button {
      cursor: pointer;
      font-weight: inherit;
      padding: 0 1.25rem;
      position: relative;
      text-align: left;
      span {
        left: 0;
        position: absolute;
      }
    }
  }
  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
`;
export const ListItemContent = styled.div `
  font-size: 90%;
  padding: 1rem 1.25rem;
  img {
    clear: right;
    float: right;
    margin: 0 0 1rem 1rem;
    max-height: 250px;
    max-width: 250px;
    /* uncomment when lightbox is supported
  &:hover {
    box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }
  */
  }
  table {
    width: 100%;
    th {
      border-bottom: 1px solid ${colorCSS('N40')};
      padding: 0.3rem;
    }
    td {
      border-top: 1px solid ${colorCSS('N40')};
      padding: 0.3rem;
    }
  }
  > *:last-child {
    margin-bottom: 0;
  }
`;
//# sourceMappingURL=UiAccordion.styles.js.map